import Vue from 'vue'
import SvgIcon from '@common/components/SvgIcon'// svg component

// register globally
Vue.component('svg-icon', SvgIcon)

const req = require.context('./svg', true, /\.svg$/)

const requireAll = requireContext => requireContext.keys().map(requireContext)

const designerIcons = requireAll(req)
 
if (process.env.NODE_ENV === 'development') {
    window.__designerIcons__ = designerIcons.map(module => {
        const name = module.default && module.default.id.split('icon-')[1]
        const group = name.includes('.') ? name.split('.')[0] || 'default' : 'default'
        return {
            name,
            group,
            value: `<svg-icon name="${name}" style="color:#666666;font-size:24px" />`,
        }
    })
}
